import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue';
import { getClerkStatus, ErrorMessage } from '@/lib/api/clerk';
import clerk from '@/lib/clerk';
import sharedMessages from '@/lib/shared-messages';


export default /*#__PURE__*/_defineComponent({
  __name: 'SamlLoginErrorPage',
  setup(__props) {

const errorMessage = ref<ErrorMessage | undefined>();

onMounted(async () => {
  errorMessage.value = await getClerkStatus();

  await clerk.client?.destroy();
});

return { __sfc: true,errorMessage, sharedMessages }
}

})